import React from "react";

import { Api, type MonitorCheckStatus } from "../../../../../../common/openapi";

import { MonitorStatusMetrics } from "./MonitorStatusMetrics";
import { MonitorStatusUnhealthyDetails } from "./MonitorStatusUnhealthyDetails";

export interface MonitorStatusDetailsProps {
	monitorStatus: MonitorCheckStatus;
}

export const MonitorStatusDetails: React.FC<MonitorStatusDetailsProps> = ({ monitorStatus }) => {
	if (
		monitorStatus.health === Api.HealthStateValue.CRITICAL ||
		monitorStatus.health === Api.HealthStateValue.DEVIATING
	) {
		return <MonitorStatusUnhealthyDetails monitorStatus={monitorStatus} />;
	}

	if (monitorStatus.health === Api.HealthStateValue.CLEAR && monitorStatus.metrics.length > 0) {
		return <MonitorStatusMetrics metrics={monitorStatus.metrics} />;
	}

	return null;
};
